import { render, staticRenderFns } from "./snp.vue?vue&type=template&id=7d9961a8&scoped=true&"
import script from "./snp.vue?vue&type=script&lang=js&"
export * from "./snp.vue?vue&type=script&lang=js&"
import style0 from "./snp.vue?vue&type=style&index=0&id=7d9961a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9961a8",
  null
  
)

export default component.exports